import React from "react";
import { Gift } from "lucide-react";
import { Section, FadeUp, SectionHeading, CtaButton } from "./primitives";
import { bonuses } from "@/data/content";

export const Bonuses = () => (
  <Section className="bg-zinc-50">
    <div className="max-w-[1100px] mx-auto">
      <FadeUp className="text-center max-w-[720px] mx-auto">
        <SectionHeading>Bonus Training Included</SectionHeading>
      </FadeUp>
      <div className="mt-12 grid gap-6 md:grid-cols-2 max-w-[900px] mx-auto">
        {bonuses.map((b, i) => (
          <FadeUp key={b.title} delay={i * 0.05}>
            <div
              data-testid={`bonus-card-${i}`}
              className="h-full bg-white border border-zinc-200 rounded-xl p-8 md:p-10 shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <Gift className="h-8 w-8 text-[#D90429]" />
              <h3 className="mt-4 text-xl font-bold text-zinc-900">{b.title}</h3>
              <p className="mt-2 text-base text-zinc-600 leading-relaxed">{b.text}</p>
            </div>
          </FadeUp>
        ))}
      </div>
      <FadeUp delay={0.1}>
        <div className="mt-14 flex justify-center">
          <CtaButton testid="cta-bonus-apply" />
        </div>
      </FadeUp>
    </div>
  </Section>
);
